import { Component, inject } from '@angular/core';
import { LayoutBase } from '@app2/core/layout/layout.base';
import { RouterLink, RouterOutlet } from '@angular/router';
import { BottomBarComponent } from '@app2/core/components/bottom-bar/bottom-bar.component';
import { AsideBarComponent } from '@app2/core/components/aside-bar/aside-bar.component';
import { SearchWidgetComponent } from '@app2/features/search-widget/search-widget.component';
import { Store } from '@ngrx/store';
import { userSelectors } from '@store/user';
import { sessionSelectors } from '@store/session';
import { FapsStore } from '@app2/store/faps/faps.store';
import { FooterComponent } from '@app2/core/components/footer/footer.component';

@Component({
  selector: 'sens-search-layout',
  imports: [
    RouterOutlet,
    BottomBarComponent,
    AsideBarComponent,
    RouterLink,
    SearchWidgetComponent,
    FooterComponent,
  ],
  templateUrl: './search.layout.html',
  styleUrl: './search.layout.scss',
  standalone: true,
})
export class SearchLayoutComponent extends LayoutBase {

  private readonly store = inject(Store);

  private readonly fapsStore = inject(FapsStore);

  user = this.store.selectSignal(userSelectors.selectUserData);

  isSetUser = this.store.selectSignal(sessionSelectors.selectIsSetUser);

  onLogoClick() {
    this.fapsStore.loadByQuery({ p:1, defaultList: true });
  }
}
